import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	formTitle: {
		id: 'ptc.ip.form.title.people.experiment',
		defaultMessage: 'Add people',
		description: 'The default title for the invite users form',
	},
	formTitleProduct: {
		id: 'ptc.ip.users.form.title.product.people.experiment',
		defaultMessage: 'Add people to {product}',
		description:
			'A title for the invite users form stating to which product users should be invited',
	},
	formMoreActionsButtonLabel: {
		id: 'ptc.ip.form.moreActionsDropdown.label',
		defaultMessage: 'More actions',
		description: 'The label of the the more actions drop down menu button',
	},
	formManageAccessSettingsLabel: {
		id: 'ptc.ip.form.siteAccessSettings.label',
		defaultMessage: 'Site access settings',
		description: 'The label of the manage access settings link in the drop down menu',
	},
	formOpenInNewWindowAriaLabel: {
		id: 'ptc.ip.form.dropdown.aria.label',
		defaultMessage: 'Open in new window',
		description:
			'The aria label of an icon from a dropdown menu that opens a new window/tab when clicked',
	},
	sendInviteButton: {
		id: 'ptc.ip.form.sendButton.count.experiment',
		defaultMessage: `{numberOfInputs, plural,
        =0 {Add}
        one {Add {numberOfInputs} person}
        other {Add {numberOfInputs} people}}`,
		description:
			'Text for send invite button. Should be one of "Add", "Add 1 person", "Add n people"',
	},
	usersSendInviteButton: {
		id: 'ptc.ip.users.form.sendButton',
		defaultMessage: 'Add teammates',
		description: 'Text for Send invite button',
	},
	cancelButton: {
		id: 'ptc.ip.form.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Text for cancel invite button',
	},
	invalidEmailMessage: {
		id: 'ptc.ip.form.invalid-email-message',
		defaultMessage: 'Please enter a valid email address',
		description: 'Error message to be shown when the users adds an invalid email address',
	},
	emptyEmailMessage: {
		id: 'ptc.ip.form.empty-email-message.person',
		defaultMessage: 'Choose at least one person',
		description:
			'Error message to be shown when the user tries to submit the invite form without add any email',
	},
	noProductSelectedMessage: {
		id: 'ptc.ip.form.no-product-selected-message.choose.alt',
		defaultMessage: 'Select at least one product',
		description:
			'Error message to be shown when the user tries to submit the invite form with no product selected',
	},
	productSelect: {
		id: 'ptc.ip.form.select-products.label.choose.experiment',
		defaultMessage: 'Add to other Atlassian products?',
		description: 'Label for product select field',
	},
	productSelectNoCurrentProduct: {
		id: 'ptc.ip.form.select-products.label.no.current.product',
		defaultMessage: 'Select one or more products',
		description: 'Label for product select field when no there are no current products',
	},
	jiraCoreMessage: {
		id: 'ptc.ip.form.jira-core-message',
		defaultMessage: 'Jira Core is included with other Jira products.',
		description: 'Warning message to be shown when the user select any of the Jira products',
	},
	optionIncludedWithOtherJiraProducts: {
		id: 'people-and-teams.invite-people.form.option-included-with-other-jira-products',
		defaultMessage: 'Included with other Jira products',
		description:
			'Shown in the product select dropdown, next to a Jira product that was included for free with other Jira products',
	},
	emailInputLabel: {
		id: 'ptc.ip.form.email-input-label',
		defaultMessage: 'Email address',
		description: 'Label to the field where the user will add the email',
	},
	inviteSuccessFlagDescriptionSingleProduct: {
		id: 'ptc.ip.flag.invite-success-flag-description-single-product',
		defaultMessage: `{inviteCount, plural, one {You've invited {emailInvited} to {product}.} other {You've invited {inviteCount} people to {product}.}}`,
		description: `This message notifies the user that they have successfully invited people to one product. The final string should read like "You've invited user@email.com to Confluence." or "You've invited 2 people to Confluence."`,
	},
	zeroRequestAccessFlagDescription: {
		id: 'ptc.ip.flag.zero-request-access-flag-description',
		defaultMessage: 'You have not requested access for anyone.',
	},
	contactSupportActionLabel: {
		id: 'ptc.ip.flag.contact-support-action-label',
		defaultMessage: 'Contact support',
	},
	viewUsersActionLabel: {
		id: 'ptc.ip.flag.view-users-action-label',
		defaultMessage: 'View users',
	},
	upgradePlanActionLabel: {
		id: 'ptc.ip.flag.upgrade-plan-action-label',
		defaultMessage: 'Upgrade plan',
	},
	jiraCoreOptionSubText: {
		id: 'ptc.ip.jira.core.option.subtext',
		defaultMessage: 'Included with other Jira products',
	},
	selectPlaceholder: {
		id: 'ptc.ip.product.select.placeholder.experiment',
		defaultMessage: 'Select products',
		description: 'Product selector placeholder text when no other products are selected',
	},
	selectAllOption: {
		id: 'ptc.ip.product.select.alloption.choose',
		defaultMessage: 'Choose all',
	},
	inviteeListUserPickerPlaceholder: {
		id: 'ptc.ip.form.invitee-list.user-picker.email.placeholder.experiment',
		defaultMessage: 'e.g., Maria, maria@company.com',
		description:
			'Placeholder to show in user picker in invitee list when no integrations are connected(This needs to be gender neutral)',
	},
	inviteeListLabel: {
		id: 'ptc.ip.form.invitee-list.label',
		defaultMessage: 'Add with email',
		description: 'Label to be shown above the invitee list text field.',
	},
	inviteeListLabelThirdParty: {
		id: 'ptc.ip.form.invitee-list-third-party.no-integrations.label.invite.experiment',
		defaultMessage: 'Names or emails',
		description: 'Label to be shown above the invitee list user picker field',
	},
	inviteSelfMessage: {
		id: 'ptc.ip.form.invalid-self-invite',
		defaultMessage: "Remove your own name or email — you can't add yourself.",
		description: 'Error message to be shown when the users attempts to invite themselves.',
	},
	invalidMultipleEmailMessage: {
		id: 'ptc.ip.form.invalid-multiple-email-message',
		defaultMessage: 'To send your invites, please correct any invalid addresses.',
		description:
			'Error message to be shown when the users adds an invalid email address to the multiple email input',
	},
	tooManyEmailAddresses: {
		id: 'ptc.ip.form.too-many-email-addresses',
		defaultMessage:
			'You can only send up to {maxEmails, plural, one {{maxEmails} email invite} other {{maxEmails} email invites}} at once.',
		description:
			'Error message to be shown when the users adds too many email addresses to the multiple email input',
	},
	tooManyEmailAddressesInProject: {
		id: 'ptc.ip.form.too-many-email-addresses-in-projects',
		defaultMessage:
			'You can only add up to {maxEmails, plural, one {{maxEmails} person} other {{maxEmails} people}} at once.',
		description:
			'Error message to be shown when the users adds too many email addresses to the multiple email input',
	},
	inviteeListNote: {
		id: 'ptc.ip.form.invitee-list.note',
		defaultMessage:
			'Enter up to {maxEmails, plural, one {{maxEmails} email address} other {{maxEmails} email addresses}}, separated by a comma.',
		description: 'Note to be shown below the invitee list text field.',
	},
	inviteeListPickerNote: {
		id: 'ptc.ip.form.invitee-list-picker.note.choose',
		defaultMessage: 'Choose at least one person',
		description:
			'Note to be shown below the invitee list user picker field if user tries to submit empty form.',
	},
	inviteeListPickerNoteAlt: {
		id: 'ptc.ip.form.invitee-list-picker.note.choose.alt',
		defaultMessage: 'Select at least one person',
		description:
			'Note to be shown below the invitee list user picker field if user tries to submit empty form.',
	},
	googleThirdPartyConnectedTooltip: {
		id: 'ptc.ip.thirdparty.google.connected.tooltip',
		defaultMessage: 'Disconnect Google',
		description: 'Tooltip to show over unlink icon for google integration',
	},
	googleThirdPartyButton: {
		id: 'ptc.ip.thirdparty.google.button',
		defaultMessage: 'Google',
		description:
			'Starts a connection flow between the users atlassian account to his google account in order to invite google users to atlassian',
	},
	microsoftThirdPartyConnectedTooltip: {
		id: 'ptc.ip.thirdparty.microsoft.connected.tooltip',
		defaultMessage: 'Disconnect Microsoft',
		description: 'Tooltip to show over unlink icon for microsoft integration',
	},
	microsoftThirdPartyButton: {
		id: 'ptc.ip.thirdparty.microsoft.button',
		defaultMessage: 'Microsoft',
		description:
			'Starts a connection flow between the users atlassian account to his microsoft account in order to invite microsoft users to atlassian',
	},
	slackThirdPartyConnectedTooltip: {
		id: 'ptc.ip.thirdparty.slack.connected.tooltip',
		defaultMessage: 'Manage this connection',
		description: 'Tooltip to show over cog icon for slack integration',
	},
	slackThirdPartyButton: {
		id: 'ptc.ip.thirdparty.slack.button',
		defaultMessage: 'Slack',
		description:
			'Opens a modal allowing the user to connect third party invites to one of his connected slack workspaces',
	},
	unknownThirdParty: {
		id: 'ptc.ip.thirdparty.unknown.button',
		defaultMessage: 'Unknown',
		description: 'Button label to handle unknown integration case',
	},
	thirdPartyConnect: {
		id: 'ptc.ip.thirdparty-connect.connect.label.people.experiment',
		defaultMessage: 'or add from',
		description: 'Label telling to user to connect teammates from listed integrations',
	},
	thirdPartyConnectedTo: {
		id: 'ptc.ip.thirdparty.connect-to.label',
		defaultMessage: 'Connected to',
		description: 'Label on list of connected third party sources for user invitess',
	},
	slackWorkspacesConnectDialogHeading: {
		id: 'ptc.ip.slack.workspaces.connect.dialog.heading',
		defaultMessage: 'Connect Slack workspace',
		description: 'Heading for the Connect Slack workspaces dialog',
	},
	slackWorkspacesManageDialogHeading: {
		id: 'ptc.ip.slack.workspaces.manage.dialog.heading',
		defaultMessage: 'Manage Slack connection',
		description: 'Heading for the Manage Slack workspaces dialog',
	},
	slackWorkspacesDialogBody: {
		id: 'ptc.ip.slack.workspaces.dialog.body',
		defaultMessage: 'Select one workspace that you’d like to invite users from.',
		description: 'Body for the Slack workspaces dialog',
	},
	slackWorkspacesDialogDisconnectSlack: {
		id: 'ptc.ip.slack.workspaces.dialog.disconnect.slack',
		defaultMessage: 'Disconnect Slack',
		description: 'Text for the Disconnect Slack link on the Slack workspaces dialog',
	},
	slackWorkspacesDoneButton: {
		id: 'ptc.ip.slack.workspaces.dialog.connet-workspace',
		defaultMessage: 'Connect workspace',
		description: 'Text for connectioon button in slack workspace selection dialog',
	},
	slackWorkspacesDisconnectDialogHeading: {
		id: 'ptc.ip.slack.workspaces.disconnect.dialog.heading',
		defaultMessage: 'Disconnect Slack',
		description: 'Title for the Disconnect Slack workspaces dialog',
	},
	slackWorkspacesDisconnectDialogBody: {
		id: 'ptc.ip.slack.workspaces.disconnect.dialog.body',
		defaultMessage:
			"You're about to disconnect this Slack workspace and limit your ability to search through its contacts.",
		description: 'text too shoow in the body of the Disconnect Slack workspaces dialog',
	},
	disconnectButton: {
		id: 'ptc.ip.slack.disconnect.dialog.disconnect.button',
		defaultMessage: 'Disconnect',
		description: 'Text for Disconnect slack button',
	},
	slackConnectSuccessFlagTitle: {
		id: 'ptc.ip.flag.slack-connect-success-flag-title',
		defaultMessage: '‘{workspace}’ from Slack connected',
		description: 'Flag header for slack connection',
	},
	slackConnectSuccessFlagDescription: {
		id: 'ptc.ip.flag.slack-connect-success-flag-description',
		defaultMessage: 'You can now search through this workspace’s list of contacts.',
		description: 'Flag description for slack connection',
	},
	slackDisconnectSuccessFlagTitle: {
		id: 'ptc.ip.flag.slack-disconnect-success-flag-title',
		defaultMessage: 'Slack disconnected',
		description: 'Flag header for slack disconnection',
	},
	slackDiscnnectSuccessFlagDescription: {
		id: 'ptc.ip.flag.slack-disconnect-success-flag-description',
		defaultMessage: 'You can no longer search through this workspace’s list of contacts.',
		description: 'Flag description for slack disconnection',
	},
	microsoftConnectSuccessFlagTitle: {
		id: 'ptc.ip.flag.microsoft-connect-success-flag-title',
		defaultMessage: 'Microsoft connected',
		description: 'Flag header for successful microsoft connection',
	},
	microsoftConnectSuccessFlagDescription: {
		id: 'ptc.ip.flag.microsoft-connect-success-flag-description',
		defaultMessage: 'You can now search through its list of contacts.',
		description: 'Flag description for successful microsoft connection',
	},
	googleConnectSuccessFlagTitle: {
		id: 'ptc.ip.flag.google-connect-success-flag-title',
		defaultMessage: 'Google Workspace connected',
		description: 'Flag header for successful google workspace connection',
	},
	googleConnectSuccessFlagDescription: {
		id: 'ptc.ip.flag.google-connect-success-flag-description',
		defaultMessage: 'You can now search through its list of contacts.',
		description: 'Flag description for successful google workspace connection',
	},
	errorHeading: {
		id: `ptc.ip.error-heading`,
		defaultMessage: 'Something’s gone wrong',
		description:
			'Heading of the error screen which is shown when an unknown error happens in Invite people. Usually due to failed network requests.',
	},
	errorText: {
		id: `ptc.ip.error-text`,
		defaultMessage:
			'We keep track of these errors, but feel free to contact us if refreshing doesn’t fix things',
		description: 'Text that is displayed when an unknown error happens in the Invite People.',
	},
	errorImageAltText: {
		id: `ptc.ip.error-image-alt-text`,
		defaultMessage: 'A broken robot and a number of people busy fixing it.',
		description: 'Text displayed as alt text when an error occurs in the Invite People',
	},
	viralSettingsHeading: {
		id: 'ptc.ip.viral-settings.heading.experiment',
		defaultMessage: 'Allow',
		description: 'Sub-heading for viral settings in the Invite People component',
	},
	directAccessDescription: {
		id: 'ptc.ip.viral-settings.direct-access.description.experiment',
		defaultMessage: 'Verified {domainWithStyling} email users to join.',
		description:
			'Text explaining to the user what enabling direct access will do. Will only be a single domain at any given time.',
	},
	directAccessExtendedDescription: {
		id: 'ptc.ip.viral-settings.open-invite.extended-description',
		defaultMessage: 'People in your org can join without an invite when they need to collaborate.',
		description: 'An extended description of what enabling direct access will do.',
	},
	openInviteDescription: {
		id: 'ptc.ip.viral-settings.open-invite.description.users.experiment',
		defaultMessage: 'Site users to invite other people.',
		description:
			'Text explaining to the user what enabling open invite will do, will only update the currently selected product.',
	},
	openInviteSuccessFlagTitle: {
		id: 'ptc.ip.flag.viral-settings.open-invite.success.title',
		defaultMessage: 'You updated {product} invite settings',
		description: 'The title of a notification shown to users when they enable user invites.',
	},
	openInviteSuccessFlagDescription: {
		id: 'ptc.ip.flag.viral-settings.open-invite.success.description',
		defaultMessage: 'Your teammates can now invite other people without your approval.',
		description: 'The description of a notification shown to users when they enable user invites.',
	},
	openInviteFailureFlagTitle: {
		id: 'ptc.ip.flag.viral-settings.open-invite.failure.title',
		defaultMessage: 'We couldn’t save your invite settings',
		description:
			'The title of a notification shown to users when they failed to enable user invites.',
	},
	openInviteFailureFlagDescription: {
		id: 'ptc.ip.flag.viral-settings.open-invite.failure.description',
		defaultMessage:
			'Go to Administration to allow your teammates to invite other people to {product}.',
		description:
			'The title of a notification shown to users when they failed to enable user invites.',
	},
	viralSettingsSuccessFlagActionLabel: {
		id: 'ptc.ip.flag.viral-settings.success.action-label',
		defaultMessage: 'See access settings',
		description:
			'The action label of all viral settings success notifications, shown to users when they successfully enable a viral setting.',
	},
	viralSettingsFailureFlagActionLabel: {
		id: 'ptc.ip.flag.viral-settings.failure.action-label',
		defaultMessage: 'See access settings in Administration',
		description:
			'The action label of all viral settings failure notifications, shown to users when the system failed to enable a/both viral setting.',
	},
	directAccessSuccessFlagTitle: {
		id: 'ptc.ip.flag.viral-settings.direct-access.success.title',
		defaultMessage: 'You updated {product} join settings',
		description: 'The title of a notification shown to users when they enable direct access.',
	},
	directAccessSuccessFlagDescription: {
		id: 'ptc.ip.flag.viral-settings.direct-access.success.description',
		defaultMessage:
			'New users with a verified {domains} email address can now join without an invite.',
		description: 'The description of a notification shown to users when they enable direct access.',
	},
	directAccessFailureFlagTitle: {
		id: 'ptc.ip.flag.viral-settings.direct-access.failure.title',
		defaultMessage: 'We couldn’t save your join settings',
		description:
			'The title of a notification shown to users when the system fails to enable direct access',
	},
	directAccessFailureFlagDescription: {
		id: 'ptc.ip.flag.viral-settings.direct-access.failure.description',
		defaultMessage:
			'Go to Administration to allow new users with a verified {domain} email address to join {product}.',
		description:
			'The title of a notification shown to users when the system fails to enable direct access',
	},
	viralSettingsSuccessFlagTitle: {
		id: 'ptc.ip.flag.viral-settings.success.title',
		defaultMessage: 'You updated {product} access settings',
		description:
			'The title of a notification shown to users when they enable both direct access and open invite.',
	},
	viralSettingsSuccessFlagDescription: {
		id: 'ptc.ip.flag.viral-settings.success.description',
		defaultMessage:
			'Users can invite new users, and org members with a verified {domains} email can join without an invite.',
		description:
			'The description of a notification shown to users when they enable both direct access and open invite.',
	},
	viewTeamActionLabel: {
		id: 'ptc.ip.flag.view-team-action-label',
		defaultMessage: 'View team',
		description: 'Text for view team action button on teams invite flags.',
	},
	openInviteExtendedDescription: {
		id: 'ptc.ip.viral-settings.direct-access.extended-description',
		defaultMessage: 'Your users will be able to invite new collaborators as needed.',
		description: 'An extended description of what enabling open invite will do.',
	},
	slackWorkspaceAddNewWorkspaceOption: {
		id: 'ptc.ip.slack.workspace.dropdown.add-new-workspace',
		defaultMessage: 'Add a new Workspace',
		description: 'Option which allows to add a new Slack workspace',
	},
	infiSpotlightTitle: {
		id: 'ptc.ip.thirdparty.spotlight.title',
		defaultMessage: 'Connect and find people faster',
		description: 'Spotlight title informing users of the infi feature',
	},
	infiSpotlightDescription: {
		id: 'ptc.ip.thirdparty.spotlight.description',
		defaultMessage:
			'Connect your Google, Microsoft, and Slack accounts to quickly find and add your teammates to this site.',
		description: 'Spotlight description explaining that the infi feature is available',
	},
	infiSpotlightAction: {
		id: 'ptc.ip.infi.spotlight.action',
		defaultMessage: 'OK',
		description: 'Button to close the infi spotlight',
	},
	adminSyncSlackContactsDescription: {
		id: 'ptc.ip.third.party.users.dropdown.sync-option-description',
		defaultMessage: 'Allow people to search for Slack contacts. Manage in admin.atlassian.com',
		description:
			'Dropdown option description telling admin that they can ehance collaboration by connection slack for all users',
	},
	adminSyncSlackContactsOption: {
		id: 'ptc.ip.third.party.users.dropdown.sync-option-label',
		defaultMessage: 'Help teams find Slack contacts',
		description:
			'Dropdown option label telling the admin to help teams in their org to find slack contacts',
	},
	adminManageConnectionOption: {
		id: 'ptc.ip.slack.menu.dropdown.manage-connection-label',
		defaultMessage: 'Manage Slack connection',
		description:
			'Dropdown option label telling the admin to manage the slack connection for the invite people dialog',
	},
	thirdPartyAdminOnboardingSpotlight1Heading: {
		id: 'ptc.ip.slack.admin-onboarding.spotlight1.heading',
		defaultMessage: 'Help teams find the right people',
		description: 'Heading for first step of third-party admin import onboarding',
	},
	thirdPartyAdminOnboardingSpotlight1Body: {
		id: 'ptc.ip.slack.admin-onboarding.spotlight1.body',
		defaultMessage: 'Allow users to quickly find and add people from Slack.',
		description: 'Body for first step of third-party admin import onboarding',
	},
	thirdPartyAdminOnboardingSpotlight1Next: {
		id: 'ptc.ip.slack.admin-onboarding.spotlight1.next',
		defaultMessage: 'See how',
		description: 'Button to go to second step of third-party admin import onboarding',
	},
	thirdPartyAdminOnboardingSpotlight2Body: {
		id: 'ptc.ip.slack.admin-onboarding.spotlight2.body',
		defaultMessage: 'Add Slack accounts, control access in admin.atlassian.com',
		description: 'Body for second step of third-party admin import onboarding',
	},
	thirdPartyAdminOnboardingSpotlight2Import: {
		id: 'ptc.ip.slack.admin-onboarding.spotlight1.import',
		defaultMessage: 'Add accounts',
		description:
			'Button to go to complete third-party admin import onboarding and start import process',
	},
	thirdPartyAdminOnboardingSpotlightDismiss: {
		id: 'ptc.ip.slack.admin-onboarding.spotlight.dismiss',
		defaultMessage: 'Not now',
		description: 'Button to dismiss third-party admin import onboarding',
	},
	reviewConnection: {
		id: 'ptc.ip.thirdparty.review-connection.notification',
		defaultMessage: `{integration} was disconnected because of an update. Reconnect to invite people from {integration}.`,
		description:
			'The warning notification shown to users when they need to update their connection.',
	},
	reviewConnectionTitle: {
		id: 'ptc.ip.thirdparty.review-connection.title',
		defaultMessage: 'Reconnect {integration}',
		description: 'The warning notification title when they click on the notification.',
	},
	reviewConnectionDescription: {
		id: 'ptc.ip.thirdparty.review-connection.description',
		defaultMessage: 'To continue inviting teammates from {integration}, reconnect to the app.',
		description: 'The warning notification body when they click on the notification.',
	},
	reviewAccessNoScope: {
		id: 'ptc.ip.thirdparty.review-access.no.access.notification',
		defaultMessage: `We can’t access your {integration} contacts. Let’s fix it.`,
		description: 'The warning notification shown to users when they are not fully connected.',
	},
	reviewAccessNoScopeTitle: {
		id: 'ptc.ip.thirdparty.review-access.no.acess.title',
		defaultMessage: 'Finish approving access',
		description: 'The warning notification title when they click on the notification.',
	},
	reviewAccessNoScopeDescription: {
		id: 'ptc.ip.thirdparty.review-access.no.access.description',
		defaultMessage:
			'To help you find people from {integration}, we need to access your contacts list.',
		description: 'The warning notification body when they click on the notification.',
	},
	reviewAccessPartialScope: {
		id: 'ptc.ip.thirdparty.review-access.partial.notification',
		defaultMessage: 'Check {integration} access settings',
		description: 'The warning notification shown to users when they are not fully connected.',
	},
	reviewAccessPartialAccessTitle: {
		id: 'ptc.ip.thirdparty.review-access.partial.title',
		defaultMessage: 'Accessing your {integration} {space}',
		description: 'The warning notification title when they click on the notification.',
	},
	reviewAccessPartialAccessDescription: {
		id: 'ptc.ip.thirdparty.review-access.partial.access.description',
		defaultMessage: `We can only search your {integration} contact's list. Want to find more people? Give us access to your {integration} {space} too.`,
		description: 'The warning notification body when they click on the notification.',
	},
	reviewAccessContinue: {
		id: 'ptc.ip.thirdparty.review-access.continue',
		defaultMessage: 'Continue',
		description:
			'Continue button to reconnect for the user within the notification for review access.',
	},
	reviewAccessDisconnect: {
		id: 'ptc.ip.thirdparty.review-access.disconnect',
		defaultMessage: 'Disconnect',
		description:
			'Disconnect button to be redirected to disconnect for users within the notification for review access.',
	},
	reviewAccessNotNow: {
		id: 'ptc.ip.thirdparty.review-access.not-now',
		defaultMessage: 'Not now',
		description:
			'Not now dismiss for user to dismiss message within the notification for review access.',
	},
	googleSpace: {
		id: 'ptc.ip.thirdparty.google.space',
		defaultMessage: 'Workspace',
		description: 'The GSuite term for Google',
	},
	secondarySectionHeading: {
		id: 'ptc.ip.secondary.section.heading',
		defaultMessage: 'Other products and access',
		description:
			'Heading for secondary section with both product selector and viral settings in the Invite People component',
	},
	secondarySectionHeadingWithProductSelector: {
		id: 'ptc.ip.secondary.section.heading.product.selector.only',
		defaultMessage: 'Other products',
		description:
			'Heading for secondary section with product selector only in the Invite People component',
	},
	secondarySectionHeadingWithViralSettings: {
		id: 'ptc.ip.secondary.section.heading.viral.settings.only',
		defaultMessage: 'Access',
		description:
			'Heading for secondary section with viral settings only in the Invite People component',
	},
	secondarySectionHeadingNoCurrentProduct: {
		id: 'ptc.ip.secondary.section.heading.no.current.product.and.viral.settings',
		defaultMessage: 'Select products and access',
		description:
			'Heading for secondary section when there is viral settings and no current product',
	},
	secondarySectionHeadingWithProductSelectorNoCurrentProduct: {
		id: 'ptc.ip.secondary.section.heading.no.current.product',
		defaultMessage: 'Select products',
		description: 'Heading for secondary section when there is no current product',
	},
	teamsInviteSectionHeading: {
		id: 'ptc.ip.teams-invite-section.heading',
		defaultMessage: 'Teams',
		description: 'Heading for teams invite section in the Invite People component',
	},
	teamsInviteSectionNewLozenge: {
		id: 'ptc.ip.teams-invite-section.new-lozenge',
		defaultMessage: 'New',
		description: 'Lozenge for teams invite section in the Invite People component',
	},
	teamsInviteSectionCheckboxLabel: {
		id: 'ptc.ip.teams-invite-section.checkbox-label',
		defaultMessage: 'Add invited people to a new or existing team',
		description:
			'Label for the invite people to a team checkbox in the teams invite section in the Invite People component',
	},
	teamsInviteSectionCheckboxTooltipPart1: {
		id: 'ptc.ip.teams-invite-section.checkbox-tooltip-part-1',
		defaultMessage:
			'Add invited people to a team and collaborate with @mentions, your own team profile, and search results filtered to your team.',
		description:
			'Tooltip content for the invite people to a team checkbox in the teams invite section in the Invite People component',
	},
	teamsInviteSectionCheckboxTooltipPart2: {
		id: 'ptc.ip.teams-invite-section.checkbox-tooltip-part-2',
		defaultMessage: 'You can use the same team across Atlassian products and projects.',
		description:
			'Tooltip content for the invite people to a team checkbox in the teams invite section in the Invite People component',
	},
	genericSuccessFlagTitle: {
		id: 'ptc.ip.flag.generic-success-flag-title.experiment',
		defaultMessage: 'Successfully added',
		description: 'Flag title for generic success flag',
	},
	inviteSuccessFlagDescriptionSingleProductNamed: {
		id: 'ptc.ip.flag.invite-success-flag-description-single-product.named.experiment',
		defaultMessage: `{lessThanFiveInviteNames, select,
      true {We sent {formattedInviteNames} a Slack message confirming you added them to {product}.}
      other {We sent a Slack message to <b>everyone</b> confirming you added them to {product}.}}`,
		description: `This message notifies the user that they have successfully invited people to one product. If less than 5 people are invited, it will include a list of user's first names e.g. "Alex, Bob, Candice and Dennis"`,
	},
	inviteSuccessFlagDescriptionSingleProductEmail: {
		id: 'ptc.ip.flag.invite-success-flag-description-single-product.email.experiment',
		defaultMessage: `{inviteCount, plural,
      one {We sent an email to <b>{emailInvited}</b> confirming you added them to {product}.}
      other {We sent an email to <b>everyone</b> confirming you added them to {product}.}}`,
		description: `This message notifies the user that they have successfully invited people to one product. If only one email is invited, it will show the email invited`,
	},
	inviteSuccessFlagDescriptionMultipleProductsEmail: {
		id: 'ptc.ip.flag.invite-success-flag-description-multiple-products.email.experiment',
		defaultMessage: `{inviteCount, plural,
      one {We sent an email to <b>{emailInvited}</b> confirming you added them.}
      other {We sent an email to <b>everyone</b> confirming you added them.}}`,
		description: `This message notifies the user that they have successfully invited people. If only one email is invited, it will show the email invited`,
	},

	requestAccessSuccessFlagTitle: {
		id: 'ptc.ip.flag.request-access-success-flag-title.experiment',
		defaultMessage: `Access request sent to your admin`,
		description: 'Flag title for generic request access flag',
	},
	requestAccessSuccessFlagDescription: {
		id: 'ptc.ip.flag.request-access-success-flag-description.experiment',
		defaultMessage: `{requestAccessCount, plural, one {Your admin needs to approve access for <b>{emailRequestedAccess}</b>.} other {Your admin needs to approve access for <b>everyone</b>.}}`,
		description: 'This message notifies the user that they have requested access',
	},
	hybridSuccessFlagTitle: {
		id: 'ptc.ip.flag.hybrid-success-flag-title.experiment',
		defaultMessage: 'Nearly done...',
		description: 'Flag title for hybrid flags of invite and request access',
	},
	hybridSuccessFlagDescriptionOneEach: {
		id: 'ptc.ip.flag.hybrid-success-flag-description-one-each.experiment',
		defaultMessage:
			'<p><b>{emailInvited}</b> has been added.</p><p>An access request for <b>{emailRequestedAccess}</b> has been sent to your admin.</p>',
		description:
			'This message notifies the user they have invited one person and requested access for one person',
	},
	invitedHybridPlural: {
		id: 'ptc.ip.flag.invited-hybrid-plural.experiment',
		defaultMessage: `{inviteCount, plural, one {You added <b>{emailInvited}</b>} other {You've added {inviteCount} people}}`,
		description: `This is a segment of a larger message which notifies the user that they have invited people and requested access for others. The final string should read like "You've added alex@email.com and requested access for 2 others" or "You've added 2 people and requested access for alex@email.com" or "You've added 2 people and requested access for 3 others"`,
	},
	requestAccessHybridPlural: {
		id: 'ptc.ip.flag.request-access-hybrid-plural.experiment',
		defaultMessage:
			'{requestAccessCount, plural, one {requested access for <b>{emailRequestedAccess}</b>} other {requested access for {requestAccessCount} others}}',
		description: `This is a segment of a larger message which notifies the user that they have invited people and requested access for others. The final string should read like "You've added alex@email.com and requested access for 2 others" or "You've added 2 people and requested access for alex@email.com" or "You've added 2 people and requested access for 3 others"`,
	},
	hybridSuccessFlagDescription: {
		id: 'ptc.ip.flag.hybrid-success-flag-description.experiment',
		defaultMessage:
			'{invitedHybridPluralCoreInvitesOptimisation}, and {requestAccessHybridPluralCoreInvitesOptimisation}.',
		description: `This message notifies the user that they have invited people and requested access for others. The final string should read like "You've added alex@email.com and requested access for 2 others" or "You've added 2 people and requested access for alex@email.com" or "You've added 2 people and requested access for 3 others"`,
	},
	inviteFailedFlagTitle: {
		id: 'ptc.ip.flag.invite-failed-flag-title.experiment',
		defaultMessage: `{failedInviteCount, plural, one {Can't add this person right now} other {We can't add those people right now}}`,
	},
	inviteFailedFlagDescription: {
		id: 'ptc.ip.flag.invite-failed-flag-description.experiment',
		defaultMessage: `We {failedInviteCount, plural, one {can't add <b>{emailFailedToInvite}</b> right now.} other {couldn’t send {failedInviteCount} of your invites}}. {isAdmin, select, false {Contact your admin for help.} other { }}`,
		description: `This message notifies the admin or user their invites have failed`,
	},
	requestAccessFailedFlagTitleCoreInvitesOptimisation: {
		id: 'ptc.ip.flag.request-access-failed-flag-title.experiment',
		defaultMessage: `Access request wasn't sent`,
	},
	requestAccessFailedFlagDescriptionCoreInvitesOptimisation: {
		id: 'ptc.ip.flag.request-access-failed-flag-description.experiment',
		defaultMessage: `{failedRequestCount, plural, one {We can't request access for <b>{emailRequestedAccess}</b>. Contact your admin for help.} other {We can't send those access requests. Contact your admin for help}}`,
		description: `This message notifies the user that the access requests have failed`,
	},
	genericFailedFlagTitle: {
		id: 'ptc.ip.flag.generic-failed-flag-title.experiment',
		defaultMessage: 'Something went wrong',
	},
	genericFailedFlagDescription: {
		id: 'ptc.ip.flag.generic-failed-flag-description.experiment',
		defaultMessage:
			"We can't add anyone right now. {isAdmin, select, false {Contact your admin for help.} true {} other {}}",
		description: `This message notifies the user that their invite and request have failed`,
	},
	licenceExceededFlagDescription: {
		id: 'ptc.ip.flag.license-exceeded-flag-description.experiment',
		defaultMessage:
			"{userRole, select, admin {You've reached your user limit. Upgrade your plan or remove other users.} other {You've reached your user limit. Contact your admin for help.}}",
		description:
			'This is special message when users cannot be invited due to license exceeded error',
	},
	licenceExceededFlagTitle: {
		id: 'ptc.ip.flag.license-exceeded-flag-title.experiment',
		defaultMessage: "Can't add more people",
		description: 'This is title message when users cannot be invited due to license exceeded error',
	},
	addMorePeopleActionLabel: {
		id: 'ptc.ip.flag.add-more-people-action-label.experiment',
		defaultMessage: 'Add more people',
	},
	manageUserAccessActionLabel: {
		id: 'ptc.ip.flag.manage-user-access-action-label',
		defaultMessage: 'Manage user access',
		description: 'Manage user access action shown after a single user has been invited',
	},
	manageUsersAccessActionLabel: {
		id: 'ptc.ip.flag.manage-users-access-action-label',
		defaultMessage: 'Manage users access',
		description: 'Manage user access action shown after multiple users have been invited',
	},
	gotItActionLabelCoreInvitesOptimisation: {
		id: 'ptc.ip.flag.ok-got-it-action-label.experiment',
		defaultMessage: 'OK, got it',
	},
	formUserManagementLabel: {
		id: 'ptc.ip.form.userManagement.label',
		defaultMessage: 'User management',
		description: 'The label of the user management link in the drop down menu',
	},
	adminDropdownItemGroupTitle: {
		id: 'ptc.ip.dropdown-menu.admin.title',
		defaultMessage: 'Admin',
	},
	connectToDropdownItemGroupTitle: {
		id: 'ptc.ip.dropdown-menu.connect-to.title',
		defaultMessage: 'Connect More',
	},
	manageConnectionsDropItemGroupTitle: {
		id: 'ptc.ip.dropdown-menu.manage-connections.title',
		defaultMessage: 'Manage Connections',
	},
	revokeGoogleMenuItemTitle: {
		id: 'ptc.ip.dropdown-menu.revoke-google.title',
		defaultMessage: 'Revoke Google',
	},
	manageSlackMenuItemTitle: {
		id: 'ptc.ip.dropdown-menu.manage-slack.title',
		defaultMessage: 'Manage Slack',
	},
	revokeMicrosoftMenuItemTitle: {
		id: 'ptc.ip.dropdown-menu.revoke-slack.title',
		defaultMessage: 'Revoke Microsoft',
	},
	noInvitePermissionTitle: {
		id: 'ptc.ip.no-invite-permission.title',
		defaultMessage: "You can't invite people",
		description: 'A title for the invite users when a user do not have permission to invite',
	},
	defaultNoInvitePermissionDescription: {
		id: 'ptc.ip.no-invite-permission.description',
		defaultMessage:
			"You don't have permission to invite people to {productName}. Contact your admin for more information.\n",
		description:
			'The default note to inform a user the reason they cannot proceed with the invite flow',
	},
	noInvitePermissionButtonTitle: {
		id: 'ptc.ip.no-invite-permission.button.title',
		defaultMessage: 'OK',
		description: 'Text for "Acknowledge" button. Clicking it will close the invite flow',
	},
	optionalMessageLabel: {
		id: 'ptc.ip.form.invite-optional-message.label',
		defaultMessage: 'Add a personalized message (Optional)',
		description: 'Label text for optional message box',
	},
	optionalMessageCharacterCountHelper: {
		id: 'ptc.ip.form.invite-optional-message.character-count-helper',
		defaultMessage: `{count, plural, one {{count} character remaining} other {{count} characters remaining}}`,
		description: `Helper text to inform the user about current character limit`,
	},
	copyLinkTooltipText: {
		id: 'ptc.elements.share.copylink.tooltip.text',
		defaultMessage: 'Copied!',
		description: 'Default text for the Copy Link tooltip',
	},
	copyLinkButtonText: {
		id: 'ptc.elements.share.copylink.button.text',
		defaultMessage: 'Copy link',
		description: 'Default text for the Copy Link button',
	},
	copiedToClipboardMessage: {
		id: 'ptc.elements.share.copied.to.clipboard.message',
		defaultMessage: 'Link copied to clipboard',
		description: 'Default text for the copied link message',
	},
	noProductSelectedMessageAppify: {
		id: 'ptc.ip.form.no-product-selected-message.choose-appify',
		defaultMessage: 'Choose at least one app',
		description:
			'Error message to be shown when the user tries to submit the invite form with no product selected',
	},
	productSelectAppify: {
		id: 'ptc.ip.form.select-products.label.choose.experiment-appify',
		defaultMessage: 'Add to other Atlassian apps?',
		description: 'Label for product select field',
	},
	productSelectNoCurrentProductAppify: {
		id: 'ptc.ip.form.select-products.label.no.current.product-appify',
		defaultMessage: 'Select one or more apps',
		description: 'Label for product select field when no there are no current products',
	},
	optionIncludedWithOtherJiraProductsAppify: {
		id: 'people-and-teams.invite-people.form.option-included-with-other-jira-products-appify',
		defaultMessage: 'Included with other Jira apps',
		description:
			'Shown in the product select dropdown, next to a Jira product that was included for free with other Jira products',
	},
	selectPlaceholderAppify: {
		id: 'ptc.ip.product.select.placeholder.experiment-appify',
		defaultMessage: 'Select apps',
		description: 'Product selector placeholder text when no other products are selected',
	},
	secondarySectionHeadingAppify: {
		id: 'ptc.ip.secondary.section.heading-appify',
		defaultMessage: 'Other apps and access',
		description:
			'Heading for secondary section with both product selector and viral settings in the Invite People component',
	},
	secondarySectionHeadingWithProductSelectorAppify: {
		id: 'ptc.ip.secondary.section.heading.product.selector.only-appify',
		defaultMessage: 'Other apps',
		description:
			'Heading for secondary section with product selector only in the Invite People component',
	},
	secondarySectionHeadingNoCurrentProductAppify: {
		id: 'ptc.ip.secondary.section.heading.no.current.product.and.viral.settings-appify',
		defaultMessage: 'Select apps and access',
		description:
			'Heading for secondary section when there is viral settings and no current product',
	},
	secondarySectionHeadingWithProductSelectorNoCurrentProductAppify: {
		id: 'ptc.ip.secondary.section.heading.no.current.product-appify',
		defaultMessage: 'Select apps',
		description: 'Heading for secondary section when there is no current product',
	},
	noProductSelectedMessageAltAppify: {
		id: 'ptc.ip.form.no-product-selected-message.choose.alt-appify',
		defaultMessage: 'Select at least one app',
		description:
			'Error message to be shown when the user tries to submit the invite form with no product selected',
	},
	contextualNoteBase: {
		id: 'ptc.ip.contextual-note-base',
		defaultMessage: `{invitingUser} needs to work with {invitedUser}{hasSpace, select, true { on {spaceName}} other {}}.{hasPriority, select, true { {priority} priority.} other {}}{hasDuedate, select, true { Their work is due on {duedate}.} other {}}`,
		description: 'A contextual note conditionally created for request access reasons.',
	},
});
